import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ensureExists } from '../../common/src/util';
import { AppProviders } from './app_providers.tsx';
import { localStorageGet, LocalStorageKey } from './data/client_local_storage.ts';
import './index.css';
import { router } from './routes.tsx';
import { isInsideMobileApp } from './util/billing';
import { reportRecoverableError } from './util/crash.ts';
import { getDevice, getPlatform } from './util/platform';
import { initializeApp } from './util/startup';

initializeApp(router.navigate);

const platform = `Platform: ${getPlatform()}`;
const device = `Device: ${getDevice()}`;
const mobileApp = `Mobile App: ${isInsideMobileApp()}`;
const bundleHash = `Bundle Hash: ${localStorageGet(LocalStorageKey.BundleHash)}`;
const userAgent = `User Agent: ${navigator.userAgent}`;
const household = localStorageGet(LocalStorageKey.Household);
const householdEmail = `Household Email: ${household?.householdEmail}`;
const orgIds = `Org IDs: [${household?.orgIds?.join(', ') ?? 'none'}]`;
const currentOrgId = `Current Org ID: ${localStorageGet(LocalStorageKey.CurrentOrgId)}`;
console.log();
console.log('***************************************************************************************');
console.log(`${platform}, ${device}, ${mobileApp}, ${bundleHash}`);
console.log(`${userAgent}`);
console.log(`${householdEmail}, ${orgIds}, ${currentOrgId}`);

const rootElement = ensureExists(document.querySelector('#root'));
ReactDOM.createRoot(rootElement, { onRecoverableError: reportRecoverableError }).render(
  <React.StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </React.StrictMode>,
);
